// extracted by mini-css-extract-plugin
module.exports = {"container":"TimeInput__container___2ly4A","colon":"TimeInput__colon___2ZHHQ","input":"TimeInput__input___17WxR","label":"TimeInput__label___3rJH6"};